import React from 'react';
import { Tooltip } from '../Tooltip';

interface FormLabelProps {
  label: string;
  required?: boolean;
  tooltip?: string;
}

export const FormLabel: React.FC<FormLabelProps> = ({ label, required, tooltip }) => {
  return (
    <div className="flex items-center gap-1">
      <label className="text-sm font-medium text-gray-700">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      {tooltip && <Tooltip content={tooltip} />}
    </div>
  );
};